import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgreementData } from "../../models/agreement.model";
import { AgreementRepository } from "../../repositories/agreement.repository";

interface RetrieveWorkloadUseCaseParam {
  agreementId: number;
  level: number;
}
export class RetrieveWorkloadUseCase
  implements UseCase<RetrieveWorkloadUseCaseParam, AgreementData>
{
  constructor(private repo: AgreementRepository) {}
  execute({
    agreementId,
    level,
  }: RetrieveWorkloadUseCaseParam): Observable<AgreementData> {
    return this.repo.loadAgreement(agreementId, level);
  }
}

const retrieveHeaderInfoUseCaseFactory = (repo: AgreementRepository) =>
  new RetrieveWorkloadUseCase(repo);

export const retrieveHeaderInfoUseCaseProvider: Provider = {
  provide: RetrieveWorkloadUseCase,
  useFactory: retrieveHeaderInfoUseCaseFactory,
  deps: [AgreementRepository],
};
